 import { Component, OnInit, ViewChild, ElementRef, HostListener, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { SchedulerService } from '../../../Services/scheduler.service';
import { BryntumSchedulerComponent } from '@bryntum/scheduler-angular';
import { Scheduler, EventHelper, StoreCRUD } from '@bryntum/scheduler';
import { Router } from '@angular/router';
import { Combo, DatePicker, DateHelper, StringHelper, Editor, EventDragCreate } from '@bryntum/scheduler';
import { PopupModel, PopupButton, PopupModelReturn, MeetingAppointment, Appointment, ServiceProvider, PopupSetupModel, AdministrationAppointment, Province } from '../../../AllTableClasses';
import { PopupNotificationService } from '../../../Services/popup-notification.service';
import { NotificationPopupComponent } from '../../Components/notification-popup/notification-popup.component';
import { AdministrationPopupComponent } from '../administration-popup/administration-popup.component';
import UserSession from '../../../Config/user-session';
import { AccountService } from '../../../Services/account.service';
import { CalendarDateFormatter, CalendarEvent, CalendarEventAction, CalendarEventTimesChangedEvent, CalendarView, DAYS_OF_WEEK } from 'angular-calendar';
import { Subject, Subscription, interval } from 'rxjs';
import { CustomDateFormatter } from './custom-date-formatter.provider';
import { startOfDay, endOfDay, subDays, addDays, endOfMonth, isSameDay, isSameMonth, addHours } from 'date-fns';
import { User } from '../scheduler/day-view-scheduler/day-view-scheduler.component';
 
@Component({
  selector: 'app-scheduler',
  templateUrl: './scheduler.component.html',
  providers: [
    {
      provide: CalendarDateFormatter,
      useClass: CustomDateFormatter,
    },
  ],
  styleUrls: ['./scheduler.component.scss']
})
export class SchedulerComponent implements OnInit {
  private subscription: Subscription | undefined;

  @ViewChild('scheduler') schedulerComponent!: BryntumSchedulerComponent;
  @ViewChild('servicePopup') ServicePopup!: NotificationPopupComponent;
  @ViewChild('appointmentPopup') AppointmentPopup!: NotificationPopupComponent;
  @ViewChild('meetingPopup') MeetingPopup!: NotificationPopupComponent;
  @ViewChild('adminPopup') adminPopup!: AdministrationPopupComponent;

  userSession = UserSession;

  // Store references to the combo boxes for later use
  datePicker!: DatePicker;
  dropdownOpen = false;
  selectAllChecked = false;

  resourceFilter: any[] = [];
  filteredResources: any[] = [];
  filteredEvents: any[] = [];

  fullScheduler: boolean = true;
  toggleable: boolean = true;

  public displayDate: Date = new Date();

  public schedule: AdministrationAppointment = new AdministrationAppointment();
  public scheduleRestructured: Array<MeetingAppointment> = new Array<MeetingAppointment>();

  public meetingAppointment: MeetingAppointment = new MeetingAppointment();

  private scheduler!: Scheduler;
  public OpenSideMenu: boolean = false;
  public isTabletOrSmaller: boolean = false;

  public viewType: string = 'day';
  refresh = new Subject<void>();
  showMarker = false;

  constructor(
    private elRef: ElementRef,
    public schedulerService: SchedulerService,
    private popupNotificationService: PopupNotificationService,
    private accountService: AccountService,
    private router: Router
  ) { }

  public resources: any[] = [];
  public events: any[] = [];
  public branches: any[] = [];
  public provinces: any[] = [];
  public selectedBranch: number = 0;
  public selectedProvinceID: number = 0;
  private previousDate: Date = new Date();

  selectedResource: string | null = null; // Variable to track radio button selection
  selectedResourceID!: number;

  DateToDisplay: string = '';

  ngOnInit() {
    this.loadResourcesAndEvents(this.getCurrentDateFormatted());
    this.provincesGet();
    this.checkScreenSize(); // Initial check
    this.subscription = interval(300000).subscribe(() => {
      this.loadResourcesAndEvents(this.getCurrentDateFormatted());
    });
    setTimeout(() => {
      this.initializeWidgets();
    }, 100);
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  public getCurrentDateFormatted() {
    const today = new Date();

    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // JavaScript months are 0-based, so add 1
    const day = String(today.getDate()).padStart(2, '0');

    const hours = String(today.getHours()).padStart(2, '0');
    const minutes = String(today.getMinutes()).padStart(2, '0');
    const seconds = String(today.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.checkScreenSize();
    if (this.isTabletOrSmaller) {
      this.setDefaultResource();
    }
  }

  checkScreenSize() {
    const screenWidth = window.innerWidth;
    this.isTabletOrSmaller = screenWidth <= 768;
  }

  public SideMenuToggle() {
    let schedulerElement = document.querySelector('.calendar-menu-toggle');
    let schedulerSidebar = document.querySelector('.scheduler-container .sidebar');
    switch (this.OpenSideMenu) {
      case true:
        this.OpenSideMenu = false;
        schedulerElement?.classList.remove('schedulerSideMenu');
        schedulerSidebar?.classList.remove('schedulerSideMenu');
        break;
      case false:
        this.OpenSideMenu = true;
        schedulerElement?.classList.add('schedulerSideMenu');
        schedulerSidebar?.classList.add('schedulerSideMenu');
        break;
    }


  }

  schedulerProps = {
    startDate: new Date(), 
    endDate: new Date(),
    viewPreset: {
      base: 'hourAndDay',
      tickHeight: 75,
      headers: [{
        unit: 'hour',
        dateFormat: 'HH:mm'
      }]
      
    },
    barMargin: 10,
    eventStyle: null,
    rowHeight: 500,
    resourceImagePath: 'assets/images/',
    timeAxis: {
      continuous: false,
      generateTicks(start: any, end: any, unit: any, increment: any) {
        const ticks = [];
        let tickStart = new Date(start.getFullYear(), start.getMonth(), start.getDate(), 7, 0, 0); // Start at 8 AM
        let tickEnd = new Date(start.getFullYear(), start.getMonth(), start.getDate(), 18, 0, 0);  // End at 6 PM

        while (tickStart < tickEnd) {
          ticks.push({
            startDate: tickStart,
            endDate: DateHelper.add(tickStart, 0.5, unit)
          });
          tickStart = DateHelper.add(tickStart, 0.5, unit);
        }

        return ticks;
      }
    },
    regionResizeFeature: false,
    createEventOnDblClick: false,
    eventDragCreate: false,
    eventMenu: false,
    eventEditFeature: false,
    eventDragFeature: false,
    eventResizeFeature: false,
    timeAxisHeaderMenuFeature: {
      items: {
        eventsFilter: false,
        zoomLevel: false,
        dateRange: false
      },
    },
    subGridConfigs: {
      locked: {
        width: 100,
        minWidth: 100
      },
      normal: {
        width: 100
      }
    },
    resourceColumns: {
      columnWidth: 200
    },
    eventRenderer({ eventRecord, resourceRecord, renderData }: any) {

      renderData.eventColor = eventRecord.Color;

      const startTime = DateHelper.format(eventRecord.startDate, 'HH:mm');
      const endTime = DateHelper.format(eventRecord.endDate, 'HH:mm');

      if (eventRecord.IsEmployeeMeeting === false) {
        return `
        <div style="background-color: ${eventRecord.color}; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; width: 100vw;">
          <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; padding: 2px 0;">
            <div class="event-thumbs-up show-status-${eventRecord.HasArrived}" id="thumbsup-${eventRecord.id}" >
              ${eventRecord.HasArrived == true ? `
                  <svg width="30" height="30" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_440_5264)">
                  <path d="M5.24727 8.15283L6.92675 8.15283L6.92675 12.6244L5.24727 12.6244C5.15329 12.6244 5.06317 12.5871 4.99672 12.5206C4.93027 12.4541 4.89294 12.364 4.89294 12.2701L4.89294 8.50715C4.89294 8.41318 4.93027 8.32306 4.99672 8.25661C5.06317 8.19017 5.15329 8.15283 5.24727 8.15283Z" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6.92676 8.15256L8.72671 5.27547C8.79646 5.16175 8.89449 5.06804 9.01122 5.00346C9.12796 4.93888 9.25944 4.90565 9.39284 4.90698C9.4979 4.90318 9.60266 4.92049 9.70091 4.95788C9.79918 4.99526 9.88894 5.05196 9.96492 5.12463C10.0409 5.1973 10.1015 5.28446 10.1432 5.38097C10.185 5.47747 10.2069 5.58135 10.2078 5.68648L10.2078 7.74863L13.3187 7.74863C13.4337 7.75236 13.5465 7.78038 13.6499 7.83085C13.7532 7.88131 13.8447 7.95308 13.9184 8.04143C13.992 8.12979 14.0461 8.23273 14.0771 8.34348C14.1081 8.45424 14.1153 8.57031 14.0982 8.68404L13.5313 12.3406C13.5072 12.5361 13.4124 12.7159 13.2649 12.8464C13.1175 12.9769 12.9274 13.0491 12.7305 13.0493L8.08184 13.0493C7.86055 13.0501 7.64213 12.9992 7.44406 12.9004L6.93384 12.6454" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6.92676 8.15266L6.92676 12.6242" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_440_5264">
                  <rect width="10" height="10" fill="white" transform="translate(4.5 4)"/>
                  </clipPath>
                  </defs>
                </svg>

              ` :
              ` <svg width="30" height="30" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_440_5264)">
                  <path d="M5.24727 8.15283L6.92675 8.15283L6.92675 12.6244L5.24727 12.6244C5.15329 12.6244 5.06317 12.5871 4.99672 12.5206C4.93027 12.4541 4.89294 12.364 4.89294 12.2701L4.89294 8.50715C4.89294 8.41318 4.93027 8.32306 4.99672 8.25661C5.06317 8.19017 5.15329 8.15283 5.24727 8.15283Z" stroke="#848789" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6.92676 8.15256L8.72671 5.27547C8.79646 5.16175 8.89449 5.06804 9.01122 5.00346C9.12796 4.93888 9.25944 4.90565 9.39284 4.90698C9.4979 4.90318 9.60266 4.92049 9.70091 4.95788C9.79918 4.99526 9.88894 5.05196 9.96492 5.12463C10.0409 5.1973 10.1015 5.28446 10.1432 5.38097C10.185 5.47747 10.2069 5.58135 10.2078 5.68648L10.2078 7.74863L13.3187 7.74863C13.4337 7.75236 13.5465 7.78038 13.6499 7.83085C13.7532 7.88131 13.8447 7.95308 13.9184 8.04143C13.992 8.12979 14.0461 8.23273 14.0771 8.34348C14.1081 8.45424 14.1153 8.57031 14.0982 8.68404L13.5313 12.3406C13.5072 12.5361 13.4124 12.7159 13.2649 12.8464C13.1175 12.9769 12.9274 13.0491 12.7305 13.0493L8.08184 13.0493C7.86055 13.0501 7.64213 12.9992 7.44406 12.9004L6.93384 12.6454" stroke="#848789" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6.92676 8.15266L6.92676 12.6242" stroke="#848789" stroke-linecap="round" stroke-linejoin="round"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_440_5264">
                  <rect width="10" height="10" fill="white" transform="translate(4.5 4)"/>
                  </clipPath>
                  </defs>
                </svg>`
              }
            </div>
            <div class="event-icons">
              <div class="event-icons" style="margin-top: 5px; margin-bottom: 10px; display: flex; justify-content: center;">
                ${eventRecord.Location ? `
                  <svg width="24" height="24" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.71434 5.96571C9.71491 5.88639 9.69891 5.80783 9.66742 5.73503C9.63594 5.66223 9.58965 5.59678 9.53148 5.54285L6.00006 2.28571L2.46864 5.54285C2.41048 5.59678 2.36419 5.66223 2.33271 5.73503C2.30122 5.80783 2.28524 5.88639 2.28578 5.96571V9.14285C2.28578 9.29439 2.34598 9.43976 2.45315 9.54691C2.56031 9.65405 2.70566 9.71428 2.85721 9.71428H9.14291C9.29445 9.71428 9.43982 9.65405 9.54697 9.54691C9.65417 9.43976 9.71434 9.29439 9.71434 9.14285V5.96571Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M6 9.71427V7.42856" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                ` : ''}
                ${eventRecord.AppointmentNotes ? `
                  <svg width="24" height="24" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.85718 8H9.14289" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M4.57141 3.71426H7.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M4.57141 5.14285H7.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9.14289 2.28571H3.42861C3.11301 2.28571 2.85718 2.54154 2.85718 2.85713V9.14285C2.85718 9.45845 3.11301 9.71428 3.42861 9.71428H8.57146C8.88706 9.71428 9.14289 9.45845 9.14289 9.14285V2.28571Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                ` : ''}
                ${eventRecord.IsAdminCheckOut ? `
                  <svg width="24" height="24" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.28577 9.00012V3.00014C2.28577 2.84859 2.34597 2.70324 2.45313 2.59608C2.5603 2.48891 2.70564 2.42871 2.8572 2.42871H4.96577C5.0963 2.42491 5.2242 2.46593 5.32817 2.54495C5.43214 2.62396 5.50591 2.73621 5.5372 2.863L5.71434 3.57157H9.14291C9.29445 3.57157 9.43982 3.63177 9.54697 3.73893C9.65411 3.8461 9.71434 3.99144 9.71434 4.143V9.00012C9.71434 9.15172 9.65411 9.29703 9.54697 9.40417C9.43982 9.51137 9.29445 9.57155 9.14291 9.57155H2.8572C2.70564 9.57155 2.5603 9.51137 2.45313 9.40417C2.34597 9.29703 2.28577 9.15172 2.28577 9.00012Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M4.57153 7.14303L5.42868 7.71446L7.14296 5.42874" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                ` : ''}
                ${eventRecord.IsAudiologistCheckOut ? `
                  <svg width="24" height="24" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                   <g clip-path="url(#clip0_440_5238)">
                   <path d="M2.25012 2.55037C2.45183 1.97406 3.2455 0.821442 4.80646 0.821442C6.75768 0.821442 7.87753 2.47981 7.5357 4.03231C7.23931 5.3784 6.39954 5.84768 6.02906 6.16877C5.48785 6.63781 5.48801 7.02051 5.2917 7.63959C5.17817 7.99772 4.78364 8.50834 4.23407 8.57128C3.83579 8.61686 3.35609 8.42734 2.84289 7.7742" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                   <path d="M3.41107 3.39007C3.52794 3.10149 3.9448 2.53805 4.67739 2.59304C5.40997 2.64803 6.03899 3.39007 5.77965 4.07858C5.52031 4.76708 5.17756 4.55394 4.86579 5.01714C4.55401 5.48033 4.67047 6.4097 3.97662 6.54847C3.54439 6.63492 3.31738 6.38688 3.31738 6.38688" stroke="white" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
                   </g>
                   <defs>
                   <clipPath id="clip0_440_5238">
                   <rect width="9" height="9" fill="white" transform="translate(0 0.5)"/>
                   </clipPath>
                   </defs>
                  </svg>
                ` : ''}
              </div>
            </div>
            <div class="event-thumbs-down show-status-${eventRecord.HasArrived}" id="thumbsdown-${eventRecord.id}">
              ${eventRecord.HasArrived == false ? `
                  <svg width="30" height="30" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_440_5265)">
                      <path d="M13.7527 9.84717L12.0732 9.84717L12.0732 5.37564L13.7527 5.37564C13.8467 5.37564 13.9368 5.41293 14.0033 5.47943C14.0697 5.54585 14.1071 5.636 14.1071 5.72993L14.1071 9.49285C14.1071 9.58682 14.0697 9.67694 14.0033 9.74339C13.9368 9.80983 13.8467 9.84717 13.7527 9.84717Z" stroke="#FF0000" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M12.0732 9.84744L10.2733 12.7245C10.2035 12.8382 10.1055 12.932 9.98878 12.9965C9.87204 13.0611 9.74056 13.0944 9.60716 13.093C9.5021 13.0968 9.39734 13.0795 9.29909 13.0421C9.20082 13.0047 9.11106 12.948 9.03508 12.8754C8.95911 12.8027 8.89847 12.7155 8.85676 12.619C8.81505 12.5225 8.79311 12.4186 8.79223 12.3135L8.79223 10.2514L5.68127 10.2514C5.56634 10.2476 5.45349 10.2196 5.35013 10.1692C5.24677 10.1187 5.15527 10.0469 5.08163 9.95857C5.00799 9.87021 4.95391 9.76727 4.92291 9.65652C4.89191 9.54576 4.8847 9.4297 4.90177 9.31596L5.4687 5.65935C5.49284 5.46392 5.58763 5.28407 5.73506 5.15357C5.88249 5.02307 6.07256 4.95092 6.26949 4.95071L10.9182 4.95071C11.1395 4.94985 11.3579 5.00078 11.5559 5.09957L12.0662 5.35464" stroke="#FF0000" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M12.0732 9.84734L12.0732 5.37578" stroke="#FF0000" stroke-linecap="round" stroke-linejoin="round"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_440_5265">
                      <rect width="10" height="10" fill="white" transform="translate(14.5 14) rotate(-180)"/>
                      </clipPath>
                      </defs>
                  </svg>
              ` :
              `<svg width="30" height="30" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_440_5265)">
                  <path d="M13.7527 9.84717L12.0732 9.84717L12.0732 5.37564L13.7527 5.37564C13.8467 5.37564 13.9368 5.41293 14.0033 5.47943C14.0697 5.54585 14.1071 5.636 14.1071 5.72993L14.1071 9.49285C14.1071 9.58682 14.0697 9.67694 14.0033 9.74339C13.9368 9.80983 13.8467 9.84717 13.7527 9.84717Z" stroke="#848789" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12.0732 9.84744L10.2733 12.7245C10.2035 12.8382 10.1055 12.932 9.98878 12.9965C9.87204 13.0611 9.74056 13.0944 9.60716 13.093C9.5021 13.0968 9.39734 13.0795 9.29909 13.0421C9.20082 13.0047 9.11106 12.948 9.03508 12.8754C8.95911 12.8027 8.89847 12.7155 8.85676 12.619C8.81505 12.5225 8.79311 12.4186 8.79223 12.3135L8.79223 10.2514L5.68127 10.2514C5.56634 10.2476 5.45349 10.2196 5.35013 10.1692C5.24677 10.1187 5.15527 10.0469 5.08163 9.95857C5.00799 9.87021 4.95391 9.76727 4.92291 9.65652C4.89191 9.54576 4.8847 9.4297 4.90177 9.31596L5.4687 5.65935C5.49284 5.46392 5.58763 5.28407 5.73506 5.15357C5.88249 5.02307 6.07256 4.95092 6.26949 4.95071L10.9182 4.95071C11.1395 4.94985 11.3579 5.00078 11.5559 5.09957L12.0662 5.35464" stroke="#848789" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12.0732 9.84734L12.0732 5.37578" stroke="#848789" stroke-linecap="round" stroke-linejoin="round"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_440_5265">
                  <rect width="10" height="10" fill="white" transform="translate(14.5 14) rotate(-180)"/>
                  </clipPath>
                  </defs>
              </svg>`
              }
            </div>
          </div>
          <span style="font-weight: light; color: black; justify-content: left; padding: 5px 0;">${eventRecord.PatientName}</span>
          <span style="display: block; height: 1px; background-color: #000; width: 100%;"></span>
          <span style="font-weight: bold; color: black; justify-content: left; padding: 5px 0">${eventRecord.ServiceName}</span>
          <span style="display: block; height: 1px; background-color: #000; width: 100%;"></span>
          <span style="font-weight: light; color: black; justify-content: left; padding: 5px 0">${eventRecord.AppointmentNotes || ''}</span>
        </div>`;
      } else {
        return StringHelper.xss`
        <div style="background-color: ${eventRecord.color}; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; width: 100vw;">
            <div style="display: flex; justify-content: center; align-items: center; width: 100%; padding: 2px 0;">
              <div style="color: black; background-color: white; padding: 3px 8px; font-size: 10px; margin-bottom: 5px;">
                ${startTime} - ${endTime}
              </div>
            </div>
            <span style="font-weight: bold; color: black; justify-content: left; padding: 5px 0">${eventRecord.ServiceName || ''}</span>
            <span style="display: block; height: 1px; background-color: #000; width: 100%;"></span>
            <span style="font-weight: bold; color: black; justify-content: left; padding: 5px 0">${eventRecord.Location || ''}</span>
            <span style="display: block; height: 1px; background-color: #000; width: 100%;"></span>
        </div>
        `
      }
      
      },
    scheduleMenuFeature: {
      items: {
        // Add new options to the context menu
        addEvent: {
          text: 'Add Appointment',
          icon: false,
          onItem: ({ resourceRecord, date }: any) => {
            const formattedDate = DateHelper.format(date, 'YYYY-MM-DD');
            const formattedTime = DateHelper.format(date, 'HH:mm');
            this.AddAppointment(resourceRecord.id, formattedDate, formattedTime, this.selectedBranch);
          }},
        leave: {
          text: 'Leave',
          cls: 'b-separator',
          onItem: ({ resourceRecord, date }: any) => {
            const formattedDate = DateHelper.format(date, 'YYYY-MM-DD');
            const formattedTime = DateHelper.format(date, 'HH:mm');
            this.AddInternalAppointment('Leave', resourceRecord.id, formattedDate, formattedTime, this.selectedBranch);
          
          }
        },
        meeting: {
          text: 'Meeting',
          cls: 'b-separator',
          onItem: ({ resourceRecord, date }: any) => {
            const formattedDate = DateHelper.format(date, 'YYYY-MM-DD');
            const formattedTime = DateHelper.format(date, 'HH:mm');
            this.AddMeeting(formattedDate, formattedTime, 32, resourceRecord.id, this.selectedBranch);

          }
        },
        training: {
          text: 'Training',
          cls: 'b-separator',
          onItem: ({ resourceRecord, date }: any) => {
            const formattedDate = DateHelper.format(date, 'YYYY-MM-DD');
            const formattedTime = DateHelper.format(date, 'HH:mm');
            this.AddMeeting(formattedDate, formattedTime, 31, resourceRecord.id, this.selectedBranch);

          }
        },
        administration: {
          text: 'Administration',
          cls: 'b-separator',
          onItem: ({ resourceRecord, date }: any) => {
            const formattedDate = DateHelper.format(date, 'YYYY-MM-DD');
            const formattedTime = DateHelper.format(date, 'HH:mm');
            this.AddInternalAppointment('Administration', resourceRecord.id, formattedDate, formattedTime, this.selectedBranch);

          }
        },
        lunch: {
          text: 'Lunch',
          cls: 'b-separator',
          onItem: ({ resourceRecord, date }: any) => {
            const formattedDate = DateHelper.format(date, 'YYYY-MM-DD');
            const formattedTime = DateHelper.format(date, 'HH:mm');
            this.AddMeeting(formattedDate, formattedTime, 34, resourceRecord.id, this.selectedBranch);

          }
        }
      }
      },
    eventTooltipFeature: {
      template({ eventRecord }: any) {
        if (eventRecord.isEmployeeMeeting === true) {
          return StringHelper.xss`
          <span style="font-weight: light; color: white; justify-content: left; padding: 5px 0;">${DateHelper.format(eventRecord.startDate, 'LT')} - ${DateHelper.format(eventRecord.endDate, 'LT')}</span>
          <span style="display: block; height: 1px; background-color: #000; width: 100%;"></span>
          <span style="font-weight: bold; color: white; justify-content: left; padding: 5px 0">${eventRecord.ServiceName || ''}</span>
          <span style="display: block; height: 1px; background-color: #000; width: 100%;"></span>
          <span style="font-weight: light; color: white; justify-content: left; padding: 5px 0">${eventRecord.Location || ''}</span>`
         
        } else {
          return StringHelper.xss`
          <span style="font-weight: light; color: white; justify-content: left; padding: 5px 0;">${DateHelper.format(eventRecord.startDate, 'LT')} - ${DateHelper.format(eventRecord.endDate, 'LT')}</span>
          <span style="display: block; height: 1px; background-color: #000; width: 100%;"></span>
          <span style="font-weight: light; color: white; justify-content: left; padding: 5px 0;">${eventRecord.PatientName || ''}</span>
          <span style="display: block; height: 1px; background-color: #000; width: 100%;"></span>
          <span style="font-weight: bold; color: white; justify-content: left; padding: 5px 0">${eventRecord.ServiceName || ''}</span>
          <span style="display: block; height: 1px; background-color: #000; width: 100%;"></span>
          <span style="font-weight: light; color: white; justify-content: left; padding: 5px 0">${eventRecord.AppointmentNotes || ''}</span>
          <span style="display: block; height: 1px; background-color: #000; width: 100%;"></span>
          <span style="font-weight: light; color: white; justify-content: left; padding: 5px 0">${eventRecord.Location || ''}</span>
          `

        }
      }
        
    }
  };

  ngAfterViewInit(): void {
    // Store Scheduler instance
    this.scheduler = this.schedulerComponent.instance;
    const { scheduler } = this;

    EventHelper.addListener(scheduler.element, {
      element: this.scheduler.element, // Target the scheduler's DOM element
      delegate: '.event-thumbs-up', // Target the custom-icon button
      click: (event: any) => {
        const target = event.target.closest('.event-thumbs-up');
        if (target && target.id) {
          const eventId = target.id.split('-')[1]; // Extract event ID from the button's ID
          const eventRecord = this.scheduler.eventStore.getById(eventId);
          this.onThumbsupClick(eventRecord);
        }
      },
      once: false, // Listen multiple times
    });

    EventHelper.addListener(scheduler.element, {
      element: this.scheduler.element, // Target the scheduler's DOM element
      delegate: '.event-thumbs-down', // Target the custom-icon button
      click: (event: any) => {
        const target = event.target.closest('.event-thumbs-down');
        if (target && target.id) {
          const eventId = target.id.split('-')[1]; // Extract event ID from the button's ID
          const eventRecord = this.scheduler.eventStore.getById(eventId);
          this.onThumbsdownClick(eventRecord);
        }
      },
      once: false, // Listen multiple times
    });

  }

  onThumbsupClick(eventRecord: any): void {
    eventRecord.HasArrived = true;

    this.schedulerService.HasArrivedSet(eventRecord.id, true, (data: any) => {
      if (data.Success) {

      }
    }, (error: any) => {
      console.log('Error posting arrival status:', error);
    });
  }

  onThumbsdownClick(eventRecord: any): void {
    eventRecord.HasArrived = false;

    this.schedulerService.HasArrivedSet(eventRecord.id, false, (data: any) => {
      if (data.Success) {

      }
    }, (error: any) => {
      console.log('Error posting arrival status:', error);
    });
  }

  onBranchSelect(event: any) {
    const selectedBranchId = event.target.value;
    this.schedulerService.ResourcesGetByBranchID(selectedBranchId, (data: any) => {
      if (data.Success) {
        this.resources = JSON.parse(data.Data);

        // Update scheduler resources once they are fetched
        const schedulerInstance = this.schedulerComponent.instance;
        schedulerInstance.resources = this.resources;

        this.resourceFilter = this.resources.map((resource: any) => ({
          id: resource.id,  // Assuming the resource has an 'id' field
          name: resource.name,  // Assuming the resource has a 'name' field
          selected: false,
          BranchID: resource.BranchID
        }));

      } else {
        console.error('Error fetching resources:', data.Message);
      }
    }, (error: any) => {
      console.error('Error fetching resources:', error);
    });

    if (selectedBranchId === '0') {
      // If '0', load all resources (staff)
      this.resourceFilter = this.resources.map((resource: any) => ({
        id: resource.id,
        name: resource.name,
        selected: false,
        BranchID: resource.BranchID
      }));
    } else {
      // Filter resources based on the selected branch
      this.resourceFilter = this.resources
        .filter((resource: any) => resource.BranchID === parseInt(selectedBranchId, 10))
        .map((resource: any) => ({
          id: resource.id,
          name: resource.name,
          selected: false,
          BranchID: resource.BranchID
        }));
    }
  }

  zoomLevel = 1;

  onToggle() {
    if (this.fullScheduler == true) {
      this.fullScheduler = false;
      this.zoomLevel = 0.7;
    } else {
      this.fullScheduler = true;
      this.zoomLevel = 1;
      setTimeout(() => {
        this.initializeWidgets();

      }, 100);
    }
  }

  onProvinceSelect(event: any) {
    this.BranchGetByProvinceID();
  }

  BranchGetByProvinceID() {
    this.schedulerService.BranchGetByProvinceID(this.selectedProvinceID, (data: any) => {
      if (data.Success) {
        this.branches = JSON.parse(data.Data);
        if (this.branches.length > 0) {
          this.selectedBranch = this.branches[0].ID;

          // Trigger branch selection logic
          this.onBranchSelect({ target: { value: this.selectedBranch } });
        }
      }
    }, (error: any) => {
      console.log('Error fetching branches:', error);
    });
  }

  // Load resources and events from the service
  loadResourcesAndEvents(selectedDate: string, BranchID: number = UserSession.BranchID) {
    debugger;
    this.schedulerService.AppointmentsGet(selectedDate, UserSession.BranchID,(data: any) => {
      if (data.Success) {
        this.events = JSON.parse(data.Data);
        const schedulerInstance = this.schedulerComponent.instance;
        schedulerInstance.events = this.events;
      } else {
        console.error('Error fetching events:', data.Message);
      }
    }, (error: any) => {
      console.error('Error fetching events:', error);
    });

    // Assuming there is a ResourcesGet method in your service
    this.schedulerService.ResourcesGetByBranchID(BranchID, (data: any) => {
      if (data.Success) {
        this.resources = JSON.parse(data.Data);

        // Update scheduler resources once they are fetched
        const schedulerInstance = this.schedulerComponent.instance;
        schedulerInstance.resources = this.resources;

        this.resourceFilter = this.resources.map((resource: any) => ({
          id: resource.id,  // Assuming the resource has an 'id' field
          name: resource.name,  // Assuming the resource has a 'name' field
          selected: false,
          BranchID: resource.BranchID
        }));

      } else {
        console.error('Error fetching resources:', data.Message);
      }
    }, (error: any) => {
      console.error('Error fetching resources:', error);
    });
  }

  // Initialize ComboBox and DatePicker Widgets
  initializeWidgets() {
    this.selectedProvinceID = UserSession.ProvinceID;
    this.BranchGetByProvinceID();
    this.selectedBranch = UserSession.BranchID;
    this.DateToDisplay = DateHelper.format(new Date(), 'DD MMMM YYYY');
    // DatePicker for Date Selection
    this.datePicker = new DatePicker({
      date: new Date(),
      width: '23vw',
      tbar: {
        // Remove all navigation buttons
        items: {
          prevYear: null,
          nextYear: null,
        }
      },
      onSelectionChange: ({ selection }) => {
        this.onDateSelect(selection[0]);
      },
      appendTo: this.elRef.nativeElement.querySelector('#date-picker-container')
    });

  }

  provincesGet() {
    this.schedulerService.ProvinceGet((data: any) => {
      if (data.Success) {
        this.provinces = JSON.parse(data.Data);
      } else {
        console.error('Error fetching events:', data.Message);
      }
    }, (error: any) => {
      console.error('Error fetching events:', error);
    });
  }

  toggleDropdown(): void {
    this.dropdownOpen = !this.dropdownOpen;
  }

  updateFilteredResources(): void {
    // Filter the resources array based on whether the `selected` property is true
    this.filteredResources = this.resourceFilter.filter(resourceFilter => resourceFilter.selected);
    const selectedResourceIds = this.filteredResources.map(resourceFilter => resourceFilter.id);

    this.filteredEvents = this.events.filter(event => selectedResourceIds.includes(event.resourceId));

    // Pass the filtered resources to the scheduler instance
    const schedulerInstance = this.schedulerComponent.instance;
    schedulerInstance.resources = this.filteredResources;
    schedulerInstance.events = this.filteredEvents;
  }

  selectAll(event: any): void {
    this.resourceFilter.forEach(resourceFilter => resourceFilter.selected = event.target.checked);
    this.updateFilteredResources();
    if (this.filteredResources.length === 0) {
      this.clearFilters();
    }
  }

  onRadioGroupChange(resourceId: string): void {
    // Update the selected resource ID
    this.selectedResource = resourceId;
    this.selectedResourceID = parseInt(resourceId, 10);

    // Update the `selected` property for all resources
    this.resourceFilter.forEach(resource => {
      resource.selected = resource.id === resourceId;
    });

    // Update filtered resources and events
    if (this.viewType == 'day') {
      this.updateFilteredResources();
    }

    // Perform additional actions if the viewType is not 'day'
    if (this.viewType !== 'day') {
      this.AppointmentsGetByUserID(parseInt(resourceId, 10));
    }

    // If no resources are selected, clear filters
    if (this.filteredResources.length === 0) {
      this.clearFilters();
    }
  }

  onCheckboxChange(resourceId: string, event: Event): void {
    // Find the resource and toggle its `selected` state
    const resource = this.resourceFilter.find(r => r.id === resourceId);
    if (resource) {
      resource.selected = (event.target as HTMLInputElement).checked;
    }

    // Update filtered resources and events
    this.updateFilteredResources();

    // If no resources are selected, clear filters
    if (this.filteredResources.length === 0) {
      this.clearFilters();
    }
  }

  setDefaultResource(): void {
    if (this.resourceFilter.length > 0) {
      this.selectedResource = this.resourceFilter[0].id;
      this.selectedResourceID = this.resourceFilter[0].id;
    } else {
      this.selectedResource = null; // Handle cases where the array is empty
    }
  }

  onDateSelect(value: Date) {
    // Check if the newly selected date is in the same month as the previous date
    if (
      this.previousDate.getFullYear() !== value.getFullYear() ||
      this.previousDate.getMonth() !== value.getMonth()
    ) {
      // Different month selected, call loadResourcesAndEvents with the new date
      this.loadResourcesAndEvents(value.toISOString());
    }

    // Set the previousDate to the newly selected date
    this.previousDate = value;

    this.DateToDisplay = DateHelper.format(value, 'DD MMMM YYYY');
    this.viewDate = new Date(value);
    // Set the start date to 6 AM of the selected date


    const startDate = new Date(value.getFullYear(), value.getMonth(), value.getDate(), 6, 0, 0);
    const endDate = new Date(value.getFullYear(), value.getMonth(), value.getDate(), 18, 0, 0);
    const schedulerInstance = this.schedulerComponent.instance;
    schedulerInstance.setTimeSpan(startDate, endDate);
  }

  // Clear filters and reset combo boxes
  clearFilters() {
    this.resourceFilter.forEach(resource => resource.selected = false);
    this.filteredResources = [];
    this.filteredEvents = [];
    this.selectedResource = null;

    // Clear resources and events from scheduler instance
    const schedulerInstance = this.schedulerComponent.instance;
    schedulerInstance.resources = this.resourceFilter; // Reset to all resources
    schedulerInstance.events = this.events; // Reset to all events

  }


  public eventDblClickHandler({ eventRecord }: any) {
    this.router.navigate(['appointment-summary'], { queryParams: { result: eventRecord.id } });
  }

  public AddAppointment(resourceid: number, startDate: string, startTime: string, branchID: number) {
    let newAppointment: Appointment = new Appointment();
    let appointment_Popup: PopupSetupModel = new PopupSetupModel();

    newAppointment.StartDate = startDate;
    newAppointment.StartTime = startTime;
    newAppointment.AudiologistID = resourceid;
    newAppointment.BranchID = branchID;

    appointment_Popup.Title = 'APPOINTMENT';
    appointment_Popup.PopupAction = 'Setup';
    appointment_Popup.Data = newAppointment;
    appointment_Popup.Button = new PopupButton('Save', 'Save');
    appointment_Popup.AltButton = new PopupButton('Cancel', 'Cancel');

    this.popupNotificationService.ShowAppointmentPopup(appointment_Popup).then((res: PopupModelReturn) => {
      if (res.Result === 'Save') {
        this.Save(res.Data);
        setTimeout(() => {
          this.loadResourcesAndEvents(res.Data.StartDate);
          if (this.viewType === 'day') {
            this.scheduler.refreshRows();
          }
          else {
            this.AppointmentsGetByUserID(this.selectedResourceID);
          }

        }, 1000);
      }
      else {
        console.log('Cancel clcked');
      }
    });
  }

  public Save(appointment: Appointment) {
    let service_Popup: PopupModel = new PopupModel();
    service_Popup.Message = 'Appointment has been successfully created';
    service_Popup.MessageType = 'success';
    //service_Popup.Button = new PopupButton('View Appointment Summary', 'ViewSummary');
    service_Popup.Button = new PopupButton('Close', 'close');

    this.schedulerService.AppointmentSet(appointment, UserSession.BranchID, (data: any) => {
      if (data.Success) {
        //let ID: number = data.Data.AppointmentID;

        this.popupNotificationService.ShowPopup(service_Popup).then((res: PopupModelReturn) => {
          //if (res.Result === 'ViewSummary') {
          //  this.router.navigate(['appointment-summary'], { queryParams: { result: data.Data } });
          //}
        });
      } else {
        this.popupNotificationService.ShowPopup(service_Popup).then((res: PopupModelReturn) => {
          //if (res.Result === 'ViewSummary') {
          //  //this.router.navigate(['appointment-summary']);
          //}
        });
      }
    }, (error: any) => { });
  }

  public AddInternalAppointment(scheduleType: string, resourceid: number ,date: string, time: string, branchID: number) {
    let leave_Popup: PopupSetupModel = new PopupSetupModel();
    this.schedule = new AdministrationAppointment();

    this.schedule.StaffMemberID = resourceid;
    this.schedule.DateFron = date;
    this.schedule.StartTime = time;
    this.schedule.BranchID = branchID;

    leave_Popup.Title = scheduleType;
    leave_Popup.PopupAction = scheduleType;
    leave_Popup.Data = this.schedule;
    leave_Popup.Button = new PopupButton('Save', 'Save');
    leave_Popup.AltButton = new PopupButton('Cancel', 'Cancel');

    this.popupNotificationService.ShowAdministrationPopup(leave_Popup).then((res: PopupModelReturn) => {
      if (res.Result === 'Save') {
        this.SaveEmployeeMeeting(res.Data, branchID);
        
        setTimeout(() => {
          this.loadResourcesAndEvents(this.viewDate.toISOString(), branchID);
            this.scheduler.refreshRows();
            this.AppointmentsGetByUserID(this.selectedResourceID);
        }, 1500);
      }
      else {
        console.log('Cancel clcked');
      }
    });
  }

  public AddMeeting(date: string, time: string, spType: number, resourceid: number, branchID: number) {
    let meeting_Popup: PopupSetupModel = new PopupSetupModel();
    meeting_Popup.Title = 'MEETING, TRAINING & OTHER BOOKING FORM';
    meeting_Popup.PopupAction = 'Setup';

    this.meetingAppointment.StartTime = time;
    this.meetingAppointment.StartDate = date;
    this.meetingAppointment.ServiceProviderID = spType;
    this.meetingAppointment.StaffMemberID = resourceid;
    this.meetingAppointment.BranchID = branchID;

    meeting_Popup.Data = this.meetingAppointment;  
    meeting_Popup.Button = new PopupButton('Save', 'Save');
    meeting_Popup.AltButton = new PopupButton('Cancel', 'Cancel');

    this.popupNotificationService.ShowMeetingPopup(meeting_Popup).then((res: PopupModelReturn) => {
      if (res.Result === 'Save') {
        this.SaveEmployeeMeeting(res.Data, branchID);
        setTimeout(() => {
          this.loadResourcesAndEvents(this.viewDate.toISOString(), branchID);
          this.scheduler.refreshRows();
          this.AppointmentsGetByUserID(this.selectedResourceID);
        }, 1500);
      }
      else {
        console.log('Cancel clcked');
      }
    });
  }

  public SaveEmployeeMeeting(appointmentMeeting: Array<MeetingAppointment>, BranchID: number) {
    this.schedulerService.EmployeeMeetingSet(appointmentMeeting, UserSession.UserID, BranchID, (data: any) => {
      if (data.Success) {
        let ID: number = data.Data.AppointmentID;
        let service_Popup: PopupModel = new PopupModel();
        service_Popup.Message = 'Appointment has been successfully created';
        service_Popup.MessageType = 'success';
        service_Popup.Button = new PopupButton('Close', 'close');

      } else {
        console.error('Error saving meeting:', data.Message);
      }
    }, (error: any) => {
      console.error('Error saving meeting:', error);
    });
  }

  //calendar view code
  
  activeDayIsOpen: boolean = true;
  view: CalendarView = CalendarView.Month;
  CalendarView = CalendarView;
  viewDate: Date = new Date();
  eventsCalendar: CalendarEvent[] = [
    {
      start: new Date(),
      title: 'An event',
    },
  ];
  individualEvents: any[] = [];
  weekStartsOn = DAYS_OF_WEEK.MONDAY;

  actions: CalendarEventAction[] = [
    {
      label: '<i class="fas fa-fw fa-pencil-alt"></i>',
      a11yLabel: 'Edit',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        //this.handleEvent('Edited', event);
      },
    },
    {
      label: '<i class="fas fa-fw fa-trash-alt"></i>',
      a11yLabel: 'Delete',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.events = this.events.filter((iEvent) => iEvent !== event);
        //this.handleEvent('Deleted', event);
      },
    },
  ];

  changeViewType(type: string): void {
    // Check if transitioning from 'day' view
    const wasDayView = this.viewType === 'day';

    // Update the view type
    this.viewType = type;

    if (type !== 'day') {
      if (wasDayView) {
        this.setDefaultResource();
      }

      this.AppointmentsGetByUserID(this.selectedResourceID);
      
    } else {
      this.scheduler.destroy();
    }
  }

  AppointmentsGetByUserID(UserID: number = UserSession.UserID) {
    this.schedulerService.AppointmentsGetByUserID(UserID, (data: any) => {
      if (data.Success) {
        this.individualEvents = JSON.parse(data.Data);
        this.eventsCalendar = this.individualEvents.map((event: any) => ({
          start: new Date(event.startDate), 
          end: new Date(event.endDate),     
          title: event.name,                
          color: {
            primary: event.Color || '#1e90ff', 
            secondary: event.Color || '#d1e8ff',
          },
          meta: {
            ...event,
          }
        }))
      } else {
        console.error('Error getting meeting:', data.Message);
      }
    }, (error: any) => {
      console.error('Error getting meeting:', error);
    });
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }

  eventClicked({ event }: { event: CalendarEvent }): void {
    this.router.navigate(['appointment-summary'], { queryParams: { result: event.meta.id } });
  }

  ThumbsupClick({ event }: { event: CalendarEvent }): void {
    event.meta.HasArrived = true;

    this.schedulerService.HasArrivedSet(event.meta.id, true, (data: any) => {
      if (data.Success) {
      }
    }, (error: any) => {
      console.log('Error posting arrival status:', error);
    });
  }

  ThumbsdownClick({ event }: { event: CalendarEvent }): void {
    event.meta.HasArrived = false;

    this.schedulerService.HasArrivedSet(event.meta.id, false, (data: any) => {
      if (data.Success) {
      }
    }, (error: any) => {
      console.log('Error posting arrival status:', error);
    });
  }

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  ResetDate() {
    this.DateToDisplay = DateHelper.format(new Date(), 'DD MMMM YYYY');
    this.datePicker.destroy();
    this.datePicker = new DatePicker({
      date: new Date(),
      width: '23vw',
      tbar: {
        items: {
          prevYear: null,
          nextYear: null,
        }
      },
      onSelectionChange: ({ selection }) => {
        this.onDateSelect(selection[0]);
      },
      appendTo: this.elRef.nativeElement.querySelector('#date-picker-container')
    });
  }

  addAppointment(date: Date): void {
    const formattedDate = DateHelper.format(date, 'YYYY-MM-DD');
    const formattedTime = DateHelper.format(date, 'HH:mm');
    this.AddAppointment(this.selectedResourceID, formattedDate, formattedTime, this.selectedBranch);
    this.refresh.next();
  }

  addLeave(date: Date): void {
    const formattedDate = DateHelper.format(date, 'YYYY-MM-DD');
    const formattedTime = DateHelper.format(date, 'HH:mm');
    this.AddInternalAppointment('Leave', this.selectedResourceID, formattedDate, formattedTime, this.selectedBranch);
    this.refresh.next();
  }

  addMeeting(date: Date): void {
    const formattedDate = DateHelper.format(date, 'YYYY-MM-DD');
    const formattedTime = DateHelper.format(date, 'HH:mm');
    this.AddMeeting(formattedDate, formattedTime, 32, this.selectedResourceID, this.selectedBranch);
    this.refresh.next();
  }

  addTraining(date: Date): void {
    const formattedDate = DateHelper.format(date, 'YYYY-MM-DD');
    const formattedTime = DateHelper.format(date, 'HH:mm');
    this.AddMeeting(formattedDate, formattedTime, 31, this.selectedResourceID, this.selectedBranch);
    this.refresh.next();
  }

  addAdministration(date: Date): void {
    const formattedDate = DateHelper.format(date, 'YYYY-MM-DD');
    const formattedTime = DateHelper.format(date, 'HH:mm');
    this.AddInternalAppointment('Administration', this.selectedResourceID, formattedDate, formattedTime, this.selectedBranch);
    this.refresh.next();
  }

  addLunch(date: Date): void {
    const formattedDate = DateHelper.format(date, 'YYYY-MM-DD');
    const formattedTime = DateHelper.format(date, 'HH:mm');
    this.AddMeeting(formattedDate, formattedTime, 34, this.selectedResourceID, this.selectedBranch);
    this.refresh.next();
  }
  //calendar view code end
}
